import { graphql, useStaticQuery } from 'gatsby'

import { ImageType } from '~/types/post.types'
import { imageMapper } from '~/utils/queryUtils'

export const useProfileImage = () => {
  const { file } = useStaticQuery<{ file: ImageType }>(graphql`
    {
      file(name: { eq: "IMG_1299" }) {
        childImageSharp {
          gatsbyImageData(width: 120, height: 120)
        }
        publicURL
      }
    }
  `)

  const profileImage = imageMapper(file)

  return { profileImage, publicURL: file.publicURL }
}
